import React from 'react';

const PersonAvatar = ({ src, alt, scalerClass = '' }) => (
  <div className="person-card__avatar-wrap">
    <div className={`person-card__avatar-scaler${scalerClass ? ` ${scalerClass}` : ''}`}>
      <img src={src} alt={alt} className="person-card__avatar" />
    </div>
  </div>
);

export default PersonAvatar;
